import React, { useState, useEffect } from "react";
import { useField } from "formik";
import { Image, Box, Icon } from "@chakra-ui/react";
import { IoDocumentTextOutline } from "react-icons/io5";

const PREVIEWABLE_FILE_TYPES = ["image/jpeg", "image/png"];

/**
 * Component that takes in a field name for Formik, tries to generate
 * a preview for a File object and falls back on an icon
 */
export default function FileUploadPreview({ name, ...rest }) {
  const [field] = useField(name);
  const [preview, setPreview] = useState(null);

  let fileIsPreviewable = false;
  if (field?.value?.type && PREVIEWABLE_FILE_TYPES.includes(field.value.type)) {
    fileIsPreviewable = true;
  }

  useEffect(() => {
    if (!fileIsPreviewable) return;

    let fileReader = false;
    let isCancel = false;

    fileReader = new FileReader();
    fileReader.onload = (e) => {
      const { result } = e.target;
      if (result && !isCancel) {
        setPreview(result);
      }
    };
    fileReader.readAsDataURL(field.value);

    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };

  }, [fileIsPreviewable, field.value]);

  if (!fileIsPreviewable) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        mt={5}
        aria-label="File not previewable"
      >
        <Icon as={IoDocumentTextOutline} color="integrator.500" w={24} h={24} />
      </Box>
    );
  }

  if (!preview) {
    return null;
  }

  return <Image {...rest} src={preview} aria-label="Image with a preview of your file" />;
}
